// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState as getRgaSearchResult} from '../state';

const setRgaResultListFlag = (state, action) => action.isEmptyRgaSearchResult;

export default (state = getRgaSearchResult().isEmptyRgaSearchResult, action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_SEARCH_RESULTS_FLAG]: setRgaResultListFlag
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/rga-search-result-flag.js